var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 24,
    height: 24,
    transform: "translate(20 11.689)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_61",
    "data-name": "Mask Group 61",
    transform: "translate(-20 -11.689)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(16 9.022)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M20.444,24.16l-2.3-2.3-1.253,1.253,3.556,3.556,6.222-6.222-1.253-1.253Z",
    fill: "#4469ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 0.889,
    cy: 0.889,
    r: 0.889,
    transform: "translate(8.889 6.222)",
    fill: "#4469ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 0.889,
    cy: 0.889,
    r: 0.889,
    transform: "translate(8.889 13.333)",
    fill: "#4469ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 0.889,
    cy: 0.889,
    r: 0.889,
    transform: "translate(8.889 20.444)",
    fill: "#4469ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M21.333,2.667H7.111A1.778,1.778,0,0,0,5.333,4.444V24a1.778,1.778,0,0,0,1.778,1.778h7.111V24H7.111V18.667h16V4.444A1.778,1.778,0,0,0,21.333,2.667Zm0,14.222H7.111V11.556H21.333Zm0-7.111H7.111V4.444H21.333Z",
    fill: "#4469ff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIc);
export default __webpack_public_path__ + "static/media/dataIc.4ba42ebae8688f9095df657041b46207.svg";
export { ForwardRef as ReactComponent };